// Product info: opens the ingredients label dialog (snippets/purolabs-product-tab-content.liquid) with the shared
// dialog helper: scroll lock, backdrop click and Escape close it, focus goes back to the link. Image links in the
// product copy marked `mfg-image-popup` (the capsule size chart; the old theme's popup class) open the same way, in
// a dialog made on first use. ("Customers Also Add" uses assets/purolabs-quick-add.js.)
import { openDialog, setupDialog } from '@purolabs/dialog';

if (!window.purolabsProductContent) {
  window.purolabsProductContent = true;
  const ready = new WeakSet();

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.openDialog);
      if (!(dialog instanceof HTMLDialogElement)) return;
      event.preventDefault();
      if (!ready.has(dialog)) {
        setupDialog(dialog);
        ready.add(dialog);
      }
      openDialog(dialog, opener);
      return;
    }
    const imageLink = event.target.closest('a.mfg-image-popup[href]');
    if (imageLink) {
      event.preventDefault();
      openDialog(imageDialog(imageLink), imageLink);
      return;
    }
    const close = event.target.closest('.pl-tab-label__dialog [data-close-dialog]');
    if (close) close.closest('dialog').close();
  });

  let popup;
  /** One shared dialog for image links in product copy, showing the clicked link's image. */
  function imageDialog(link) {
    if (!popup) {
      popup = document.createElement('dialog');
      popup.className = 'pl-tab-label__dialog pl-tab-label__dialog--wide';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'pl-tab-label__close';
      close.dataset.closeDialog = '';
      close.setAttribute('aria-label', 'Close');
      close.innerHTML = '<svg class="pl-icon" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
      const image = document.createElement('img');
      image.className = 'pl-tab-label__image';
      image.alt = '';
      popup.append(close, image);
      document.body.append(popup);
      setupDialog(popup);
    }
    const image = popup.querySelector('img');
    image.src = link.href.trim();
    image.alt = link.textContent.trim();
    popup.setAttribute('aria-label', link.textContent.trim() || 'Image');
    return popup;
  }
}
